var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { ITrackType, useClickstreamAnalytics } from '../clickstream-analytics-context';
import { useIntersectionObserver } from '../use-intersection-observer';
export var EgClickstreamImpressionTracker = function (_a) {
    var eventData = _a.eventData, _b = _a.trackOnce, trackOnce = _b === void 0 ? true : _b, intersectionOptions = _a.intersectionOptions, deps = _a.deps, children = _a.children;
    var track = useClickstreamAnalytics().track;
    var _c = __read(useIntersectionObserver(function (entries, intersection) {
        var _a = __read(entries, 1), entry = _a[0];
        if (entry.isIntersecting) {
            track(ITrackType.EVENT, {
                data: eventData,
                config: { isEgClickstream: true }
            });
            if (trackOnce) {
                intersection.disconnect();
            }
        }
    }, intersectionOptions, deps), 1), setRef = _c[0];
    return children ? React.createElement("div", { ref: setRef }, children) : null;
};
EgClickstreamImpressionTracker.displayName = 'EgClickstreamImpressionTracker';
//# sourceMappingURL=eg-clickstream-impression-tracker.js.map